import { Download } from 'tabler-icons-react';
import { formatBytes } from 'Utils';
import styles from 'partials/download-button.module.scss';

export const DownloadButton = ({ url, size }) => {
	return (
		<a download href={url} className={styles.action}>
			({formatBytes(size)})
			<Download size={18} className={styles.icon} />
		</a>
	);
};
